module.exports = __webpack_public_path__ + "static/media/16.8e79db26.svg";